<template>
  <div
    class="rs-card"
    v-bind="($props as any)"
  >
    <header
      v-if="hasHeaderSlot"
      class="rs-card__header"
    >
      <slot name="header" />
    </header>

    <div
      v-if="hasSlot"
      :class="cardClasses"
    >
      <slot />
    </div>

    <footer
      v-if="hasFooterSlot"
      class="rs-card__footer"
      :class="{ disabled: disableFooter }"
    >
      <slot name="footer" />
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsCard',
  props: {
    align: {
      type: String,
      default: '',
    },
    noBody: {
      type: Boolean,
      default: false,
    },
    disableFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardClasses(): Record<string, boolean> {
      return {
        'rs-card__body': !this.noBody,
      };
    },
    hasSlot(): boolean {
      const slots = Object.keys(this.$slots || {});
      return slots?.includes('default');
    },
    hasFooterSlot(): boolean {
      const slots = Object.keys(this.$slots || {});
      return slots?.includes('footer');
    },
    hasHeaderSlot(): boolean {
      const slots = Object.keys(this.$slots || {});
      return slots?.includes('header');
    },
  },
});
</script>

<style lang="scss">
  @import '@/styles/_variables.scss';
  .rs-card{
    position: relative;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    background-color: $white;
    border: $card-border;
    border-radius: $global-radius;
    .card-img{
      width: 100%;
      border-bottom: 1px solid $extra-light-gray;
      object-fit: contain;
      background-color: $extra-light-gray;
      &-top{
        border-top-left-radius:  $global-radius;
        border-top-right-radius: $global-radius;
      }
      &-bottom{
        border-bottom-left-radius:  $global-radius;
        border-bottom-right-radius: $global-radius;
      }
    }
    .rs-card__footer {
      border-bottom-left-radius:  $global-radius;
      border-bottom-right-radius: $global-radius;
      &.disabled {
        background: $gray-100;
      }
    }
  }

</style>
